// extracted by mini-css-extract-plugin
export var explainable = "_fz-a";
export var printerCard = "_fz-1";
export var printerCardConfigured = "_fz-2";
export var printerCardError = "_fz-3";
export var printerCardsContainer = "_fz-0";
export var printerIcon = "_fz-8";
export var printerIconConfigured = "_fz-5";
export var printerIconContainer = "_fz-4";
export var printerIconError = "_fz-6";
export var printerIconUnconfigured = "_fz-7";
export var workstationsTableCard = "_fz-9";